import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from 'assets/animations/loader_conlicitacao_lottie.json';

const Loader: React.FC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="text-center">
      <Lottie options={defaultOptions} style={{ width: '150px', margin: '0 auto' }} />
      Aguarde um instante.
    </div>
  );
};

export default Loader;
